export default "__VITE_ASSET__CI8hreDg__"